import { useState, useEffect, useCallback } from 'react';
import { getWhatsAppSettings, trackWhatsAppClick } from '../data/api';

let cachedSettings = null;

const DEFAULT_SETTINGS = {
  phoneNumber: '6586618699',
  contactName: 'John Tan',
  companyLabel: 'Yusen Design & Contract',
  responseTime: 'Typically replies within an hour',
  defaultMessage: "Hi! I'm interested in your interior design services. Can you help me?",
  greetingMessage: 'Hello! How can we help you with your interior design project today?',
  enabled: true,
};

export function useWhatsApp() {
  const [settings, setSettings] = useState(cachedSettings || DEFAULT_SETTINGS);

  useEffect(() => {
    if (cachedSettings) return;
    getWhatsAppSettings()
      .then(data => {
        cachedSettings = data;
        setSettings(data);
      })
      .catch(() => {});
  }, []);

  const openChat = useCallback((options = {}) => {
    const { page = 'unknown', context = '', customMessage = '' } = options;
    const message = customMessage || settings.defaultMessage;
    const encoded = encodeURIComponent(message);

    trackWhatsAppClick({ page, context, message }).catch(() => {});

    window.open(`https://wa.me/${settings.phoneNumber}?text=${encoded}`, '_blank');
  }, [settings.defaultMessage, settings.phoneNumber]);

  const getServiceMessage = useCallback((serviceName) => {
    return `Hi! I'm interested in your ${serviceName} service. Can you provide more information and a quotation?`;
  }, []);

  const getProjectMessage = useCallback((projectTitle) => {
    return `Hi! I saw your project "${projectTitle}" and would like to discuss a similar renovation. Can we chat?`;
  }, []);

  const getBlogMessage = useCallback((blogTitle) => {
    return `Hi! I just read your article "${blogTitle}" and have some questions about my renovation project.`;
  }, []);

  return { settings, openChat, getServiceMessage, getProjectMessage, getBlogMessage };
}
